// src/config/social.ts

/** 
 * 소셜 로그인 기능 토글
 * - 지금은 카카오만 잠시 비활성화
 * - 나중에 true로 바꾸면 즉시 UI/동작 살아남
 */
export const ENABLE_KAKAO = false;
export const ENABLE_NAVER = false;
